export const qaEntitySlugs = {
  TESTS: "qa_tests",
  TEST_STEPS: "qa_test_steps",
  TEST_RUNS: "qa_test_runs",
  TEST_RUN_RESULTS: "qa_test_run_results",
  ISSUES: "qa_issues",
};

export const qaAddButtonLabels = {
  [qaEntitySlugs.TESTS]: "Test",
  [qaEntitySlugs.TEST_STEPS]: "Step",
  [qaEntitySlugs.ISSUES]: "Issue",
};

export const qaEvents = {
  SUITE_MANIPULATED: "qa-suite-manipulated",
  CREATED: "created",
  UPDATED: "updated",
  DELETED: "deleted",
};
